/** Route pattern without record ids — the assistant needs the screen, not whose record it is. */
export const toRoutePattern = (pathname) =>
    pathname
        .replace(/\/[0-9a-f]{24}(?=\/|$)/gi, '/:id')
        .replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi, '/:id')
        .replace(/\/\d+(?=\/|$)/g, '/:id');

/**
 * The screen the user is on: the route pattern only. Not `document.title` — on a record's page it
 * carries the record's name (breadcrumbs set "Clients - Jane Doe"), which must never reach the model.
 */
export const pageContext = (pathname) => ({ route: toRoutePattern(pathname) });
